import { render, staticRenderFns } from "./RadioGroupSelectbox.vue?vue&type=template&id=0c005f8c&scoped=true&"
import script from "./RadioGroupSelectbox.vue?vue&type=script&lang=js&"
export * from "./RadioGroupSelectbox.vue?vue&type=script&lang=js&"
import style0 from "./RadioGroupSelectbox.vue?vue&type=style&index=0&id=0c005f8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c005f8c",
  null
  
)

export default component.exports